import MessageCenterMenu from './MessageCenterMenu'

export default MessageCenterMenu
